<template>
  <TMainForm :script-id="scriptId" :interception="interception" :buttons="buttons" :default-design="defaultDesign" ref="MainForm"
    :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript"/>
</template>

<script setup>
/**
 * TTMInjectionWellForm
 */
import TMainForm from './TMainForm.vue';
import { FORM_DESIGNS, FORM_CHANGE_SCRIPTS, FORM_PROCESS_SCRIPTS } from './constants';
import { ref, computed } from 'vue';

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: [String, Object, Boolean], default: null },
});
const MainForm = ref(null);

const buttons = computed(() => [
  {
    key: 'FACILITY_RUN',
    loadedValue: 'COMMAND_ON',
    index: 15,
    name: 'Запуск',
    click: () => MainForm.value?.writeLoadedValue('FACILITY_RUN', 'COMMAND_ON', 0),
  },
  {
    key: 'FACILITY_STOP',
    loadedValue: 'COMMAND_OFF',
    index: 16,
    name: 'Стоп',
    click: () => MainForm.value?.writeLoadedValue('FACILITY_STOP', 'COMMAND_OFF', 0),
  },
  {
    key: 'RESET_ALARM',
    index: 11,
    name: 'Сброс аварии',
    click: () => MainForm.value?.write('RESET_ALARM', 1, 0),
  },
]);

const defaultDesign = FORM_DESIGNS.TTMWellForm;
const defaultChangeScript = FORM_CHANGE_SCRIPTS.TTMWellForm;
const defaultProccessScript = FORM_PROCESS_SCRIPTS.TTMWellForm;
</script>
